/**
 * Bindet einen zusätzlichen, eigenen Google Tag Manager Container für das Kundenportal ein.
 * Ergänzt den bereits bestehenden GTM-Container (z. B. aus Sitecore) und ersetzt ihn nicht.
 *
 * Die Container-ID wird über `ENV_CONFIG.GTM_CONTAINER_ID` konfiguriert. Ist keine ID gesetzt,
 * wird nichts eingebunden.
 *
 * @see https://developers.google.com/tag-platform/tag-manager/web
 */
export function initGoogleTagManager(): void {
  const containerId = globalThis.ENV_CONFIG?.GTM_CONTAINER_ID

  if (!containerId || containerId.trim() === '') {
    return
  }

  // Verhindert doppelte Einbindung, falls initGoogleTagManager() mehrfach aufgerufen wird
  if (globalThis.document.querySelector(`script[data-gtm-id="${containerId}"]`)) {
    return
  }

  const dataLayerName = 'dataLayer'
  const win = globalThis as unknown as Record<string, unknown[]>
  win[dataLayerName] = win[dataLayerName] || []
  win[dataLayerName].push({ 'gtm.start': Date.now(), event: 'gtm.js' })

  const firstScript = globalThis.document.getElementsByTagName('script')[0]
  const script = globalThis.document.createElement('script')
  script.async = true
  script.dataset.gtmId = containerId
  script.src = `https://www.googletagmanager.com/gtm.js?id=${containerId}&l=${dataLayerName}`
  firstScript?.parentNode?.insertBefore(script, firstScript)

  const noscript = globalThis.document.createElement('noscript')
  const iframe = globalThis.document.createElement('iframe')
  iframe.src = `https://www.googletagmanager.com/ns.html?id=${containerId}`
  iframe.height = '0'
  iframe.width = '0'
  iframe.style.display = 'none'
  iframe.style.visibility = 'hidden'
  noscript.appendChild(iframe)
  globalThis.document.body.insertBefore(noscript, globalThis.document.body.firstChild)
}
